import store from '../store'
import Cookies from '@/utils/Cookies'

export function requireAccess (to, from, next) {
  let userAccessLevel // Guarda o nivel de acesso do usuário
  let userProducts = [] // Lista de produtos que usuário tem acesso

  function containsProduct (productName) {
    for (let i = 0; i < userProducts.length; i++) {
      if (userProducts[i].name === productName) {
        return userProducts[i]
      }
    }
  }

  // console.log(index.options.routes)

  /*
    Quando a página é carregada, primeiro tentamos recuperar o valor através do getter do VueX Store,
    se não for possível, tentamos recuperar o valor através de um cookie

    (Verificação necessário para quando o usuário recarregar a página, não perder a sessão)

    ------------------ (No ultimo dos casos redireciona para o login novamente) ------------------
  */

  if (store.getters.getUser != null) {
    userAccessLevel = store.getters.getUser.level_access
    userProducts = store.getters.getUser.product_access
  } else if (Cookies.get('cms-gold360')) {
    let cookie = JSON.parse(Cookies.get('cms-gold360'))
    userAccessLevel = cookie.level_access
    userProducts = cookie.product_access
  } else {
    next('/login')
  }

  switch (to.meta.permission) {
    /*
        Nesse case, se o usuário for editor, ele poderá acessar a página
      */
    case 'editor':
      if (userAccessLevel >= 2) {
        next()
      } else {
        next({
          name: 'Page401'
        })
      }
      break

      /*
        Nesse case, se o usuário for admin, ele poderá acessar a página
      */
    case 'admin':
      if (userAccessLevel === 3) {
        next()
      } else {
        next({
          name: 'Page401'
        })
      }
      break

      /*
        Nesse case, se o usuário for admin e tiver acesso aos Jobs, ele poderá acessar a página
      */
    case 'admin-jobs':
      if (userAccessLevel >= 2 && containsProduct('Empregos')) {
        console.log(userProducts)
        next()
      } else {
        next({
          name: 'Page401'
        })
      }
      break
    case 'admin-health':
      if (userAccessLevel >= 2 && containsProduct('Saúde')) {
        console.log(userProducts)
        next()
      } else {
        next({
          name: 'Page401'
        })
      }
      break
    case 'admin-travels':
      if (userAccessLevel >= 2 && containsProduct('Viagens')) {
        console.log(userProducts)
        next()
      } else {
        next({
          name: 'Page401'
        })
      }
      break
    case 'admin-fashion':
      if (userAccessLevel >= 2 && containsProduct('Fashion')) {
        console.log(userProducts)
        next()
      } else {
        next({
          name: 'Page401'
        })
      }
      break
  }
}



// WEBPACK FOOTER //
// ./src/router/permission.js